module.exports = __webpack_public_path__ + "public/SiteIcons/verifiFacebook.png?47899141";